module.exports = __webpack_public_path__ + "static/lighting_bolt_mtg_clb-c1a451e061b8e7daff567e438980bcb2.jpg";